import styled from '@emotion/styled';
import Typography from '@portalterreno/react-ui-core/Typography';

const StyledTypography = styled(Typography)({
  marginBottom: 0
});

export default StyledTypography;
